export default __webpack_public_path__ + "static/media/Group 14.bd746eab.png";